import React, { useEffect, useRef, useState } from 'react'
import { serverMessage } from './format'
import { ErrorReference } from '../error/error-reference'
import { useErrorLine } from '../error/use-error-line'

const FALLBACK = "That code didn't work. Check it and try again, or ask your organization's administrator for a new one."

// "Have a join code?" after a single sign-on that placed the person in no
// organization: a code from their organization's administrator joins that
// organization. Closed, it is one outlined button; open (or startOpen, when
// a code is the only way in), a single field. onJoin(code) resolves when the
// code worked; its rejection's server message is shown.
export const JoinCodeEntry = ({ onJoin, startOpen = false, disabled }) => {
  const [open, setOpen] = useState(startOpen)
  const [code, setCode] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, failure, setError] = useErrorLine()
  const input = useRef(null)

  useEffect(() => { if (open && !startOpen && input.current) input.current.focus() }, [open, startOpen])

  if (!open) {
    return <button type="button" className="btn sw-btn sa-block" disabled={disabled} onClick={() => setOpen(true)}>Have a join code?</button>
  }

  const handleSubmit = async e => {
    e.preventDefault()
    if (!code.trim()) return
    setBusy(true)
    setError(null)
    try {
      await onJoin(code.trim())
    } catch (exp) {
      setError(serverMessage(exp, FALLBACK), exp)
      setBusy(false)
    }
  }

  return (
    <form className="sa-form" onSubmit={handleSubmit} noValidate>
      <div className="sw-field">
        <label className="sw-label" htmlFor="sa-join-code">Join code</label>
        <input id="sa-join-code" ref={input} className="form-control sw-mono" value={code} onChange={e => setCode(e.target.value)}
          autoComplete="off" autoCapitalize="characters" spellCheck={false} placeholder="ABCD-EFGH-JK"
          aria-describedby="sa-join-code-hint" aria-invalid={error ? true : undefined} />
        <span className="sw-hint" id="sa-join-code-hint">Your organization's administrator gives you this code.</span>
      </div>
      {error && <p className="text-danger small m-0" role="alert">{error}</p>}
      {error && <ErrorReference error={failure} className="mt-0" />}
      <button type="submit" className="btn sw-btn-primary sa-block" disabled={busy || disabled || !code.trim()}>{busy ? 'Joining…' : 'Join'}</button>
    </form>
  )
}
